module.exports = __webpack_public_path__ + "img/big_1_66.ee50bb00.png";